import { Typography } from '@mui/material';
import { useCallback } from 'react';
import { HeaderRendererProps } from 'react-data-grid';
import OxSortIcon from '../../../../elements/OxDataGrid/OxSortIcon';
import { Issue, IssueSortKey } from '../../types/issues-types';

const IssueScoreHeaderCell = ({
  column,
  sortDirection,
  onSort,
}: IssueScoreHeaderCellProps) => {
  const handleSort = useCallback(() => {
    onSort(column.key as IssueSortKey);
  }, [column.key, onSort]);

  return (
    <div
      role='button'
      onClick={handleSort}
      style={{ display: 'flex', alignItems: 'center' }}>
      <Typography
        variant='body2'
        component='span'
        display='inline-block'
        lineHeight={1}
        sx={{ marginInlineStart: 0.5 }}>
        Severity
      </Typography>
      <OxSortIcon sortDirection={sortDirection} />
    </div>
  );
};
interface IssueScoreHeaderCellProps
  extends Omit<HeaderRendererProps<Issue>, 'onSort'> {
  onSort(columnKey: IssueSortKey): void;
}

export default IssueScoreHeaderCell;
